@if (isEmbed) {
  @if (errorState) {
    <div class="w-full flex justify-center registration-error">
      <mat-icon>error</mat-icon>
      <span class="error-title">Error</span>
      <span class="error-message-text"
        >An error occurred while loading the registration form. Please try again later.</span
      >
    </div>
  }
  @if (event && registrationFields && !registrationCompleted) {
    <app-registration-form
      [event]="event"
      [embed]="true"
      [registrationFields]="registrationFields"
      (formValue)="saveRegistrant($event)"
    />
  }
  @if (registrationCompleted) {
    <div class="registration-completed" [style]="{ height: '100%' }">
      <mat-icon>check_circle</mat-icon>
      <span class="success-title"> Thank you for registering! </span>
      <span class="confimation-message" [ngClass]="{ 'custom-bottom-margin': !userRegistrationId }">
        You will receive an email confirmation shortly with more information.
      </span>
      @if (userRegistrationId) {
        <div class="calendar-confirmation">
          <p>Add This Event to your Calendar.</p>
          <div class="calendar-buttons custom-bottom-margin">
            <button class="google" (click)="saveCalendar('google')">Add to Google Calendar</button>
            <button class="outlook" (click)="saveCalendar('outlook')">Add to Outlook Calendar</button>
          </div>
        </div>
      }
      <div class="footer-confirmation">
        Powered by
        <a href="https://scoot.app/" title="Scoot Page" target="_blank" rel="noopener noreferrer">
          <img alt="Scoot Logo" title="Scoot Logo" src="/assets/images/logos/scoot_logo_primary.png" />
        </a>
      </div>
    </div>
  }
} @else {
  <!-- hide until event loaded to avoid FOUC -->
  <div class="registration-wrapper" [hidden]="!event && !errorState" [style]="{ backgroundColor: event?.eventColor }">
    <div class="registration-form-card">
      @if (errorState) {
        <div class="w-full flex justify-center registration-error">
          <mat-icon>error</mat-icon>
          <span class="error-title">Error</span>
          <span class="error-message-text"
            >An error occurred while loading the registration form. Please try again later.</span
          >
        </div>
      }
      @if (event && registrationFields && !registrationCompleted) {
        <app-registration-form
          class="w-full flex justify-center"
          [event]="event"
          [registrationFields]="registrationFields"
          (formValue)="saveRegistrant($event)"
        />
      }
      @if (registrationCompleted) {
        <div class="registration-completed">
          <mat-icon>check_circle</mat-icon>
          <span class="success-title"> Thank you for registering! </span>
          <span class="confimation-message" [ngClass]="{ 'custom-bottom-margin': !userRegistrationId }">
            You will receive an email confirmation shortly with more information.
          </span>
          @if (userRegistrationId) {
            <div class="calendar-confirmation">
              <p>Add This Event to your Calendar.</p>
              <div class="calendar-buttons custom-bottom-margin">
                <button class="google" (click)="saveCalendar('google')">Add to Google Calendar</button>
                <button class="outlook" (click)="saveCalendar('outlook')">Add to Outlook Calendar</button>
              </div>
            </div>
          }
          <div class="footer-confirmation">
            Powered by
            <a href="https://scoot.app/" title="Scoot Page" target="_blank" rel="noopener noreferrer">
              <img alt="Scoot Logo" title="Scoot Logo" src="/assets/images/logos/scoot_logo_primary.png" />
            </a>
          </div>
        </div>
      }
    </div>
    <app-footer
      class="footer-desktop"
      customStyle="box-shadow: 0 -15px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);"
    />
    <div class="footer-mobile">
      <a href="https://scoot.app/" title="Scoot Page" target="_blank" rel="noopener noreferrer">
        <img alt="Scoot Logo" title="Scoot Logo" src="/assets/images/scoot_logo_reverse.png" />
      </a>
      <span class="separator"></span>
      <span class="copyright-text">
        Copyright &copy;{{ currentYear }} Scoot. Scoot is protected by
        <a
          href="https://image-ppubs.uspto.gov/dirsearch-public/print/downloadPdf/20210377062"
          target="_blank"
          rel="noopener"
          >U.S. patent 11,575,531</a
        >
        and additional pending patents. Scoot Inc. all rights reserved.
      </span>
    </div>
  </div>
}

@if (loading) {
  <div class="loading-container">
    <app-loading />
  </div>
}
